const INVENTORY_API = '/sitecore/api/ssc/isagenix/inventoryapi/1';

// Request: array of productIds to check
//    ["458acfd856cc419995894bd673877ace", "458acfd856cc419995894bd673877bdf"]
// Response: array of products and inventory count
//    [ {ItemId: "458acfd856cc419995894bd673877ace", Count: 1}, {ItemId: "458acfd856cc419995894bd673877bdf", Count: 0} ]
export async function getInventory(request) {
    return $.ajax({
        headers: {
            'Content-Type': 'application/json'
        },
        type: 'GET',
        url: `${INVENTORY_API}/getinventory`,
        contentType: 'application/json',
        dataType: 'json',
        data: {
            ids: request.join(',')
        }
    });
}

// Request: array of productIds to check
//    ["458acfd856cc419995894bd673877ace", "458acfd856cc419995894bd673877bdf"]
// Response: array of out of stock productIds
//    ["458acfd856cc419995894bd673877bdf"]
export async function getUnavailableInventory(request) {
    let unavailable = [];
    try {
        let response = await getInventory(request);
        if(!Array.isArray(response)) return unavailable;

        // check zero count
        unavailable = response.filter(i => i.Count < 1)
            .map(i => i.ItemId);

        // check if item exist in the response
        // if not, add to unavailable
        request.forEach(function(item) {
            if(!response.some(function(r) { return r.ItemId === item; })) {
                if(!unavailable.includes(item)) {
                    unavailable.push(item);
                }
            }
        });
    } catch (ex) {
        console.error(ex);
    }
    return unavailable;
}
